import { AiseaApiFactory } from "@/api/aisea/apiFactory";

const vesselCrewRepository = AiseaApiFactory.get(
  "enterpriseManningVesselCrewVisitRecord"
);

const EnterpriseManningVesselCrewVisitRecordService = (() => {
  const fetch = async id => {
    const res = await vesselCrewRepository.fetch(id);
    if (!res || !res.status) throw res;
    return res.data;
  };
  const update = async (id, data) => {
    const res = await vesselCrewRepository.update(id, data);
    if (!res || !res.status) throw res;
    return res.data;
  };
  return { fetch, update };
})();

export default EnterpriseManningVesselCrewVisitRecordService;
